import { gql } from "@apollo/client";

export const catagory = gql`
    query MyQuery {
        aatmsv4_category {
        categoryid
        }
    }
`
export const Fleets = gql`
query MyQuery(
    $id: uuid
) {
    aatmsv4_fleets(where: {clientsid: {_eq: $id}}) {
      fleetsid
      aircraft
    }
  }
`

export const AircraftForm = gql`
query M_studymat_air(
    $fleetId: uuid
    $catagories: aatmsv4_category_enum
    $clientId: uuid
    $pdf: Boolean
) {
  aatmsv4_aircraftforms(order_by: {aircraftformname: asc}, where: {clientsid: {_eq: $clientId}, _and: {fleetsid: {_eq: $fleetId}, _and: {active: {_eq: true}, _and: {studymat: {_is_null: $pdf}, category: {_eq: $catagories}}}}}) {
    fleet {
      aircraft
    }
    subcategory
    aircraftformname
    studymat
    category
    aircraftformid
  }
}
`
export const GroundFormQuery = gql`
query M_studymat_ground(
    $fleetId: uuid
    $catagories: aatmsv4_category_enum
    $clientId: uuid
    $pdf: Boolean
) {
  aatmsv4_groundforms(order_by: {groundformname: asc}, where: {clientsid: {_eq: $clientId}, _and: {fleetsid: {_eq: $fleetId}, _and: {active: {_eq: true}, _and: {studymat: {_is_null: $pdf}, category: {_eq: $catagories}}}}}) {
    fleet {
      aircraft
    }
    subcategory
    groundformname
    studymat
    category
    groundformid
  }
}
`

export const StudyMaterialQuery = gql`
query M_studymat_sim(
    $fleetId: uuid
    $catagories: aatmsv4_category_enum
    $clientId: uuid
    $pdf: Boolean
) {
    aatmsv4_simforms(order_by: {simformname: asc}, where: {clientsid: {_eq: $clientId}, _and: {fleetsid: {_eq: $fleetId}, _and: {active: {_eq: true}, _and: {studymat: {_is_null: $pdf}}}}, category: {_eq: $catagories}}) {
      fleet {
        aircraft
      }
      subcategory
      simformname
      simformid
      studymat
      category
    }
  }
`

export const getClientId = gql`
query login(
    $id: String
) {
  aatmsv4_users(where: {userid: {_eq: $id}}) {
    client {
      clientname
      clientsid
    }
  }
}
`
export const EditStudyMaterial = gql`
mutation M_studymat_EDIT_sim(
    $simFormID: uuid
    $studyMaterial: String
) {
    update_aatmsv4_simforms(where: {simformid: {_eq: $simFormID}}, _set: {studymat: $studyMaterial}) {
      returning {
        studymat
      }
    }
  }
`
export const simformName = gql`
query activeSimforms_4givenclient(
    $id: uuid
    $fleetId: uuid
) {
    aatmsv4_simforms(order_by: {simformname: asc}, where: {active: {_eq: true}, _and: {clientsid: {_eq: $id}, fleetsid: {_eq: $fleetId}}}) {
    simformid
    simformname
    studymat
    }
   }
`

export const add_study = gql`
mutation addStudyMaterial(
  $id: uuid
  $img: String
) {
  update_aatmsv4_simforms(where: {simformid: {_eq: $id}}, _set: {studymat: $img}) {
  returning {
  clientname
  fleet {
  aircraft
  }
  studymat
  }
  }
 }
`
export const add_Aircraft = gql`
mutation M_AddStudyMatAircraft(
  $id: uuid
  $img: String
) {
  update_aatmsv4_aircraftforms(where: {aircraftformid: {_eq: $id}}, _set: {studymat: $img}) {
  returning {
  clientname
  fleet {
  aircraft
  }
  aircraftformname
  studymat
  }
  }
  }
`
export const add_Ground = gql `
mutation M_AddStudyMatGround(
  $id: uuid
  $img: String
) {
  update_aatmsv4_groundforms(where: {groundformid: {_eq: $id}}, _set: {studymat: $img}) {
  returning {
  clientsname
  fleet {
  aircraft
  }
  groundformname
  studymat
  }
  }
  }
`
export const Edit_Aircraft_Form = gql`
mutation M_studymat_EDIT_air(
  $AircraftId: uuid
  $StudyMaterial: String
) {
  update_aatmsv4_aircraftforms(where: {aircraftformid:
 {_eq: $AircraftId}}, _set:
 {studymat: $StudyMaterial}) {
  returning {
  studymat
  }
  }
 }
`

export const Edit_Ground_Form = gql`
mutation M_studymat_EDIT_ground(
  $GroundFormId: uuid
  $StudyMaterail: String
) {
  update_aatmsv4_groundforms(where: {groundformid:{_eq: $GroundFormId}}, _set:{studymat:$StudyMaterail}) {
  returning {
  groundformid
  }
  }
 }
`
